import React from "react";
import { gql, useMutation } from "@apollo/client";
import { Form } from "react-final-form";
import { OnChange } from "react-final-form-listeners";

import { CircularProgress, InputAdornment } from "@mui/material";
import { Plus as AddProductIcon } from "mdi-material-ui";

import ProductSelectField from "components/form/ProductSelectField";

import OrderSidebar from "../index";

export default function AddProduct({ order }) {
  const [mutate] = useMutation(
    React.useMemo(
      () => gql`
        mutation ($orderId: ID!, $cart: [CartItemInput]) {
          UpdateOrderAdmin(orderId: $orderId, cart: $cart) {
            order {
              id
              ...OrderSidebar_order
            }
          }
        }

        ${OrderSidebar.fragments.order}
      `,
      []
    )
  );

  const handleSubmit = React.useCallback(
    ({ product }) => {
      const prepareCartItem = (cartItem) => ({
        id: cartItem.id,
        productId: cartItem.product.id,
        options: cartItem.options,
        quantity: cartItem.quantity,
      });

      return mutate({
        variables: {
          orderId: order.id,
          cart: [
            {
              product,
              options: {},
              quantity: 1,
            },
            ...order.cart,
          ].map(prepareCartItem),
        },
      })
        .then(() => {})
        .catch(() => true);
    },
    [mutate, order.id, order.cart]
  );

  if (order.paymentId) return null;

  return (
    <Form onSubmit={handleSubmit}>
      {({ form, handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit}>
          <ProductSelectField
            name="product"
            label="Ajouter un produit"
            disabled={submitting}
            isB2B={order.isB2B}
            priceTaxRate={order.taxRate}
            priceCurrency={order.currency}
            SelectProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {submitting ? (
                    <CircularProgress size="1em" />
                  ) : (
                    <AddProductIcon />
                  )}
                </InputAdornment>
              ),
            }}
          />

          <OnChange name="product">
            {async (product) => {
              if (!product) return;
              await form.submit();
              form.change("product", null);
            }}
          </OnChange>
        </form>
      )}
    </Form>
  );
}

AddProduct.fragments = {
  order: gql`
    fragment OrderSidebar_Cart_AddProduct_order on Order {
      id
      paymentId
      isB2B
    }
  `,
};
